import ColorApp from "../color/color";
function ChatrtLineOption(option = {}) {
  const label = option.label ?? [];

  return {
    chart: {
      type: "bar",
      height: 350,
      toolbar: {
        show: false,
      },
      // events: {
      //   dataPointSelection: (event, chartContext, config) => {
      //     const { seriesIndex, dataPointIndex, w } = config;
      //     if (seriesIndex === null || dataPointIndex === null) return;
      //     const categories = w?.config?.xaxis?.categories ?? w?.globals?.categoryLabels ?? []; // fallback
      //     const category = categories[dataPointIndex];
      //     const seriesName = w?.globals?.seriesNames?.[seriesIndex];
      //     const value = w?.globals?.series?.[seriesIndex]?.[dataPointIndex];
      //     // setModalDetail({ status: true, category });
      //   },
      // },
      zoom: {
        enabled: false,
      },
    },
    colors: [ColorApp().themeColor],
    stroke: {
      curve: "smooth",
      width: 1,
      colors: [ColorApp().themeColor],
    },
    tooltip: {
      fixed: {
        enabled: true,
      },
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories: label,
      labels: {
        show: true,
        style: { colors: ColorApp().inverse, fontSize: "12px", fontFamily: ColorApp().themeFont, fontWeight: ColorApp().themeFontWeight, cssClass: "apexcharts-xaxis-label" },
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: true,
      },
    },
    yaxis: {
      show: false,
    },
    grid: {
      show: false,
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val === null ? "" : val;
      },
      textAnchor: "middle",
      distributed: false,
      offsetX: 0,
      offsetY: -6,
      style: {
        fontSize: "14px",

        colors: [ColorApp().inverse],
      },
      background: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top", // Positions the label at the top of the bar
          },
        },
      },
    },
  };
}
export default ChatrtLineOption;
